import React, {Component, useEffect} from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography } from '@material-ui/core';
import connect from "react-redux/es/connect/connect";
import {getRaspaAlarmes} from "../../../actions/raspaAlarmActions";
import RaspaAlarmCountUsageTable from "./RaspaAlarmCountUsageTable";
import {changeFilter} from "../../../actions/FilterActions";
import {getFotografiaPlanta, getTempoEtapas} from "../../../actions/orderActions";
import {useDispatch, useSelector} from "react-redux";
import RaspaAlarmesTabela from "./RaspaAlarmesTabela";

//const stations = [1,2,3,4]

const styles = theme => ({
  dashboardSection: {
    margin: "5px"
  },
  sectionTitle: {
    marginBottom: theme.spacing(1) * 4,
    marginTop: theme.spacing(1) * 4
  }
})


const RaspaAlarmDashboardView = (props) => {

    const raspaAlarmes = useSelector(state => state.raspaAlarm.raspaAlarmes);
    const dispatch = useDispatch();

    useEffect( () => {

        dispatch(getRaspaAlarmes());

     }, []);


    const { classes } = props;

    console.log('alarm dashview',raspaAlarmes)

    return (
      <React.Fragment>
        <Grid container direction="column" >
          <Grid item xs={12}>
            <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} />
          </Grid>
        </Grid>

        <Grid container direction="column">
          <Grid container item direction="row" alignItems="stretch" spacing={16}>
            <Grid item xs={12}>
            </Grid>
              <Grid item xs={12}>
                    <RaspaAlarmesTabela />
              </Grid>
              <Grid item xs={12}>

              </Grid>


            </Grid>
        </Grid>

      </React.Fragment>
    );

}




export default (RaspaAlarmDashboardView);
